import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../config'; // Import the config file
import '../components/layout.css'; // Make sure to create this CSS file

const Layout = ({ isAdmin, user, handleLogout, children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className={`layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <nav className="navbar">
                <div className="navbar-brand">{config.APP_NAME}</div> {/* Use the APP_NAME from config */}
                <div className="navbar-menu">
                    {isAdmin && <Link to="/admin">Admin</Link>}
                    <div className="user-info">
                        <span className="username">Welcome, {user.name}</span>
                        {user.company && <span className="company-name">{user.company}</span>}
                        {user.profile && (
                            <img 
                                src={user.profile} 
                                alt="Profile" 
                                className="profile-image"
                            />
                        )}
                    </div>
                    <button className="logout-button" onClick={handleLogout}>Logout</button>
                </div>
            </nav>

            <div className="main-container">
                <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
                    <button className="sidebar-toggle" onClick={toggleSidebar}>
                        {sidebarOpen ? '←' : '→'}
                    </button>
                    <ul className="sidebar-menu">
                        <li><Link to="/dashboard">Dashboard</Link></li>
                        <li><Link to="/tickets">Tickets</Link></li>
                        {config.SHOW_ATTENDANCE === 'true' && <li><Link to="/attendance">Attendance</Link></li>}
                        {isAdmin && <li><Link to="/admin">Admin</Link></li>}
                        <li><Link to="/CompleteProfile">Profile</Link></li>
                    </ul>
                </aside>

                <main className="content-wrapper">
                    <div className="content">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Layout;
